export enum LessonType {
  LegacyExam = 'EXAM',
  Theory = 'THEORY',
  Revision = 'REVISION',
  Custom = 'CUSTOM',
}
